import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=8338a3da&scoped=true&"
import script from "./ResetButton.vue?vue&type=script&lang=js&"
export * from "./ResetButton.vue?vue&type=script&lang=js&"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=8338a3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8338a3da",
  null
  
)

export default component.exports